/**
 * callback单例监听
 * 与通常的监听方式不同，EventSingleton的监听回调只有一个，不会有多个，反复注册监听时会用新的callback覆盖旧的callback，确保emit时永远只有一个callback执行。
 */
export class EventSingleton {
    constructor() {
        this._event = undefined;
        this._callback = undefined;
    }
    get event() {
        if (this._event === undefined) {
            this._event = (callback) => {
                // 反复调用该方法时，_callback使用最新值
                this._callback = callback;
                return {
                    dispose: () => {
                        this._callback = undefined;
                    },
                };
            };
        }
        return this._event;
    }
    emit(params) {
        this._callback?.call(null, params);
    }
    dispose() {
        this._event = undefined;
        this._callback = undefined;
    }
}
